"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { EditorTagBadge } from '../../ComboBox/Badges/EditorTagBadge/index.mjs';
import { forwardRef } from 'react';

const TplFormula = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(EditorTagBadge, { variant: "static-value", ref, onDelete: props.onDelete, children: "Unsupported formula type" });
});
TplFormula.displayName = "TplFormula";

export { TplFormula as default };
